export type OmipFiltersModel = {
  chartType: OmipChartTypes;
  term: OmipTerms;
  month: number;
  year: number;
};

export enum OmipChartTypes {
  CURRENT_PRICE = 'CURRENT_PRICE',
  HISTORIC = 'HISTORIC',
}

export enum OmipTerms {
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  ANNUAL = 'ANNUAL',
}
